module.exports = __webpack_public_path__ + "img/IconSuccess.40f3da63.svg";